import React, { useState } from "react";
import { ReactComponent as CalendarLogo } from "../../components/ContentHeader/assets/images/calendar.svg";
import ContentHeader from "../../components/ContentHeader";
import Periods from "./components/Periods";
import Years from "./components/Years";

const UnitiesGroups: React.FC = () => {
  const [content, setContent] = useState<string>("years");

  const changeContent = (content: string) => {
      setContent(content);
  };

  return (
      <div className="wrapperApp">
          <ContentHeader
              title="Calendar Management"
              Icon={CalendarLogo}
              breadcrumb={["Calendar Management"]}
          />
          <div id="content">
              <div className="tabs">
                  <div className="tabs__buttons">
                      <button
                          className={`tabs__tablinks ${ content === "years" ? "tabs__tablinks--active" : ""}`}
                          onClick={() => { changeContent("years"); }}
                      >
                          Years
                      </button>
                      <button
                          className={`tabs__tablinks ${ content === "periods" ? "tabs__tablinks--active" : "" }`}
                          onClick={() => { changeContent("periods"); }}
                      >
                          Periods
                      </button>
                  </div>
                  <div className="tabs__tabcontent">
                      {content === "years" ? (
                          <Years />
                      ) : (
                          <Periods />    
                      )}
                  </div>
              </div>
          </div>
      </div>
  );
};
export default UnitiesGroups;
